import request from '@/config/axios'

export interface O2oConsumerUiStyleVO {
  styleKey: string
  name: string
  category: string
  primaryColor: string
  surfaceColor: string
  surfaceTopColor: string
  description?: string
  used?: boolean
}

export const O2oConsumerUiStyleApi = {
  getList: async () => {
    return await request.get({ url: '/o2o/marketing/ui-style/list' })
  },
  use: async (styleKey: string) => {
    return await request.put({ url: '/o2o/marketing/ui-style/use?styleKey=' + encodeURIComponent(styleKey) })
  }
}
